import React from 'react';

import styles from './separator.module.scss';

const Separator: React.FC = () => {
  return <div className={styles.separator} />;
};

export default Separator;
